<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M2.667 12.292c0-.574.296-1.108.783-1.413l11.667-7.292a1.667 1.667 0 011.767 0L28.55 10.88c.488.305.784.839.784 1.413v14.743c0 .92-.747 1.667-1.667 1.667H4.334c-.92 0-1.667-.746-1.667-1.667V12.292zM16 5.394l11.293 7.058L16 19.51 4.707 12.452 16 5.394zM4.667 14.785v11.917h22.667V14.785l-10.45 6.532a1.667 1.667 0 01-1.767 0l-10.45-6.532z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsMailOpenOutline'
}
</script>
